import { DndContext, DragOverlay } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useRelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { useBasicDndDragger } from '@framework/ui/core/dnd/hooks/useBasicDndDragger.ts';
import { type IMapPrintImage } from './MapPrintImage.ts';
import { MapPrintImageConfigDrawerButton } from './MapPrintImageConfigDrawerButton.tsx';
import { MapPrintImageItem } from './MapPrintImageItem.tsx';
import { MapPrintImageSortableItem } from './MapPrintImageItemSortable.tsx';

export interface IMapPrintImagesConfigSectionProps {
  name: string;
}

export function MapPrintImagesConfigSection(
  props: IMapPrintImagesConfigSectionProps,
) {
  const { name } = props;

  const editor = useRelationEditor<IMapPrintImage>(name);
  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);

  return (
    <div>
      <DndContext
        sensors={sensors}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          {editor.items.map((item, i) => (
            <MapPrintImageSortableItem
              index={item.__uid!}
              key={item.__uid}
              printImage={item}
              configMode
              onEdit={e => {
                e.preventDefault();
                e.stopPropagation();

                editor.handle.open(item);
              }}
              onRemove={e => {
                e.preventDefault();
                e.stopPropagation();
                editor.removeAt(i);
              }}
            />
          ))}

          <DragOverlay>
            {active && <MapPrintImageItem printImage={active} isDragging />}
          </DragOverlay>
        </SortableContext>
      </DndContext>
      <MapPrintImageConfigDrawerButton editor={editor} />
    </div>
  );
}
